import getLocalKeysReduxUtil from 'modules/redux/utils/get-local-keys'
import REDUX_ASSOCIATION from 'modules/redux/constants/association'

function getAssociationKeysReduxUtil (instanceOrClassName) {
  if (!instanceOrClassName) {
    return []
  }
  if (typeof instanceOrClassName === 'string') {
    return Object.keys(REDUX_ASSOCIATION[instanceOrClassName] || {})
  }
  const objOrArr = REDUX_ASSOCIATION[instanceOrClassName.className]
  const associationKeys = Array.isArray(objOrArr)
    ? objOrArr
    : Object.keys(
      (objOrArr || {})
    )
  const localKeys = getLocalKeysReduxUtil(instanceOrClassName)
  return associationKeys.filter(a => !localKeys.includes(a))
}

export default getAssociationKeysReduxUtil
